import { render } from "./PaymentComplete.vue?vue&type=template&id=06ae818c&scoped=true"
import script from "./PaymentComplete.vue?vue&type=script&lang=js"
export * from "./PaymentComplete.vue?vue&type=script&lang=js"

import "./PaymentComplete.vue?vue&type=style&index=0&id=06ae818c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ae818c"]])

export default __exports__